import Vue from "vue";
import Router from "vue-router";
import store from "@/store/";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import LoginApi from "@/services/login";
import Carrito from "./views/Carrito.vue";
import Favoritos from "./views/Favoritos.vue";
import Productos from "./views/Productos.vue";
import Bancos from "./views/Bancos.vue";
import Pagos from "./views/Pagos.vue";
import Notificaciones from "./views/Notificaciones.vue";
import Permisos from "./views/Permisos.vue";
import SinPermiso from "./views/SinPermiso.vue";
import Categoria from "./views/Categoria.vue";
import Banners from "./views/Banners.vue";
import Clientes from "./views/Clientes.vue";
import Settings from "./views/Settings.vue";
import { Loading } from "element-ui";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/",
      name: "login",
      component: Login,
      meta: {
        isPublic: true,
        isLog: true
      }
    },
    {
      path: "/categoria",
      name: "categoria",
      component: Categoria,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/pagos",
      name: "pagos",
      component: Pagos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/bancos",
      name: "bancos",
      component: Bancos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/favoritos",
      name: "favoritos",
      component: Favoritos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/banners",
      name: "banners",
      component: Banners,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/notificaciones",
      name: "notificaciones",
      component: Notificaciones,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/carrito",
      name: "carrito",
      component: Carrito,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/clientes",
      name: "clientes",
      component: Clientes,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/productos",
      name: "productos",
      component: Productos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/sinpermiso",
      name: "sinpermiso",
      component: SinPermiso,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/permisos",
      name: "permisos",
      component: Permisos,
      meta: {
        isPublic: false
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.isPublic);
  if (requiresAuth === false) {
    LoginApi.refreshtoken()
      .then(res => {
        store.dispatch("setuser", res.data.usuario);
        if (to.path == "/bancos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Bancos") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/pagos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Pagos") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/notificaciones") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Notificaciones") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/favoritos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Favoritos") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/carrito") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Carrito") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/productos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Productos") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/permisos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Empleados") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/categoria") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Categoria") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/clientes") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Clientes") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/settings") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Settings") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/banners") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webamairca.permisos) {
            for (let i = 0; i < store.state.webamairca.permisos.length; i++) {
              if (store.state.webamairca.permisos[i].ruta === "Banners") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webamairca.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webamairca.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else {
          next();
        }
      })
      .catch(error => {
        console.log(error);
        next("/");
      });
  } else {
    if (to.path == "/") {
      LoginApi.refreshtoken()
        .then(res => {
          store.dispatch("setuser", res.data.usuario);
          next("/home");
        })
        .catch(error => {
          console.log(error);
          //next("/login")
        });
    }
    next();
  }
});

export default router;
